import WangEditor from "@/views/components/WangEditor";
import { BaseItem as ZhBaseItem } from "zhihao-ui-react";
import { formatBankAccount, onlineBankAccount } from "@/views/pages/tradeManage/goodsManagement";
import { AdminTableEmpty } from "@/views/components/TableEmpty";

export interface ProductDetailMediaProps {
    imagePath?: string;
    videoPath?: string;
    advertisingPath?: string;
    advertisingIsVideo?: boolean;
}

export interface ProductDetailBankAccount {
    name?: string;
    account?: string;
    openingBank?: string;
    isOwnAccount?: number;
}

/** 复刻 Vue img-more 的固定媒体槽位，避免详情页被实际媒体尺寸撑开。 */
export function ProductDetailMedia({
    imagePath,
    videoPath,
    advertisingPath,
    advertisingIsVideo = false
}: ProductDetailMediaProps) {
    return (
        <>
            <ZhBaseItem colon={false} label="图片" labelWidth={84} span={2}>
                <div className="product-detail-media" aria-label="图片" data-testid="consignment-detail-image-slot">
                    {imagePath ? (
                        <img
                            alt="商品图片"
                            className="product-detail-media__image"
                            data-testid="consignment-detail-image"
                            src={imagePath}
                        />
                    ) : (
                        <span>暂无图片</span>
                    )}
                </div>
            </ZhBaseItem>
            <ZhBaseItem className="product-detail-video-item" colon={false} label="视频" labelWidth={56} span={2}>
                <div className="product-detail-media" aria-label="视频" data-testid="consignment-detail-video-slot">
                    {videoPath ? (
                        <video
                            className="product-detail-media__video"
                            controls
                            data-testid="consignment-detail-video"
                            src={videoPath}
                        />
                    ) : (
                        <span>暂无视频</span>
                    )}
                </div>
            </ZhBaseItem>
            {advertisingPath !== undefined ? (
                <ZhBaseItem colon={false} label="助力广告" labelWidth={56} span={4}>
                    <div className="product-detail-media" aria-label="助力广告" data-testid="product-detail-ad-slot">
                        {advertisingPath ? (
                            advertisingIsVideo ? (
                                <video
                                    className="product-detail-media__video"
                                    controls
                                    data-testid="product-detail-ad-video"
                                    src={advertisingPath}
                                />
                            ) : (
                                <img alt="助力广告" className="product-detail-media__image" src={advertisingPath} />
                            )
                        ) : (
                            <span>暂无图片</span>
                        )}
                    </div>
                </ZhBaseItem>
            ) : null}
        </>
    );
}

/** 复刻旧 Vue bank-account：线上支付使用平台账户，线下支付使用商品配置账户。 */
export function ProductDetailBankTable({
    accounts,
    payType
}: {
    accounts?: ProductDetailBankAccount[];
    payType?: number;
}) {
    const rows = [
        ...(payType !== 2 ? [{ ...onlineBankAccount, flag: "线上" }] : []),
        ...(accounts || []).map(account => ({ ...account, flag: "线下" }))
    ];

    return (
        <div className="product-detail-bank-table">
            <table aria-label="收款账户">
                <thead>
                    <tr>
                        <th>支付方式</th>
                        <th>开户名称</th>
                        <th>银行账户</th>
                        <th>开户行</th>
                        <th>是否自有账户</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.length ? (
                        rows.map((account, index) => (
                            <tr key={`${account.flag}-${account.account || index}`}>
                                <td>{account.flag}</td>
                                <td>{account.name || "--"}</td>
                                <td>{formatBankAccount(account.account)}</td>
                                <td>{account.openingBank || "--"}</td>
                                <td>{account.isOwnAccount ? "是" : "否"}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={5}>
                                <AdminTableEmpty />
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}

/** 详情态沿用旧 Vue 的无工具栏只读 WangEditor，保证图片、视频和段落按 HTML 渲染。 */
export function ProductDetailRichText({ value }: { value?: string }) {
    if (!value) return <>--</>;
    return (
        <div className="product-detail-rich-text">
            <WangEditor disabled hideToolBar height="auto" value={value} />
        </div>
    );
}
